export class SkillList {
    id: string;
    name: string;
    skills: string[];
}
